import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { IApplicationState } from '../../Store';

import '../../App.css';

import { History } from 'history';
import { RouteComponentProps } from 'react-router-dom';
import { IDashboardState } from '../../Store/Dashboard/Types';

import { ISearchState } from '../../Store/Search/Types';
import { IUserState } from '../../Store/User/Types';
import { ElectionType, IDeclarationCSAFilters, IDeclarationDetail, IElectionsState } from '../../Store/Elections/Types';
import { getXlsDeclarationCSA } from '../../Store/Elections/Actions';
import { capitalize } from '../../Utils/String';
import { ElectionTableDetails } from './ElectionTableDetails';

interface IPropsFromState {
  i18n: I18N;
  localeInfos: ILocaleInfos;
  router: RouteComponentProps<{}>;
  dashboard: IDashboardState;
  search : ISearchState;
  user: IUserState;
  elections: IElectionsState;
}

interface IPropsFromDispatch {
  getXlsDeclarationCSA: typeof getXlsDeclarationCSA
}

interface IState {
  activeTab: ElectionType;
}

interface IOwnProps {
  history: History;
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles &
    IPropsFromState &
    IPropsFromDispatch&
    IOwnProps;

const styles = (theme:any) => MD.createStyles({
    
  }
)

export class DeclarationsCSAContentComponent extends React.Component<AllProps, IState> {

  public constructor(props: AllProps) {
      super(props);
      this.state = {
        activeTab: ElectionType.NATIONAL
      }
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {
    return state
  }

  private buildColumns() {
    const { i18n } = this.props
    let dataCopy:any = []
    let headerStyle= {
      backgroundColor: "#dadada",
      color: 'black',
      flex: '100 0 auto',
      fontSize: '0.875rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 300,
      width: '70px',
      cursor: 'pointer'
    }
    this.props.elections.decalarion_details !== null && this.props.elections.decalarion_details.map((x:IDeclarationDetail) => {
      let jsonData:any = {}
      jsonData["media"] = x.A_NOMFICHE
      jsonData["mediaId"] = x.IDFICHEMEDIA
      jsonData["type emission"] = x.B_TYPEEMISSION
      jsonData["date"] = x.C_DATEEMISSION
      jsonData["heure debut"] = x.D_HEUREDEBUT
      jsonData["heure fin"] = x.E_HEUREFIN
      jsonData["titre emission"] = x.F_TITREEMISSION
      jsonData["intervenant"] = x.G_INTERVENANT
      jsonData["qualité"] = x.H_QUALITE
      jsonData["appartenance"] = x.I_GROUPEPOLITIQUE
      jsonData["code election"] = x.K_CodeElection
      jsonData["circonscription"] = x.L_CIRCONSCRIPTION
      jsonData["code list"] = x.M_CodeListeElec
      jsonData["type intervenant"] = x.N_TypeIntervenant
      jsonData["situation intervenant"] = x.O_SituationIntervernant
      jsonData["cumul temps parole"] = x.P_CUMULTEMPSPAROLE
      
      dataCopy.push(jsonData)
      return dataCopy
    })
    let columns:any = []
    dataCopy.map((x:any) => {
      Object.keys(x).map((key:any, index: number) => {
        if (x[key] === undefined || key === "mediaId") {
          columns[index] = {
            Header: capitalize(i18n._(`${key}`)),
            accessor: key,
            show: false,
          }
        } else {
        columns[index] = {
            Header: capitalize(i18n._(`${key}`)),
            accessor: key,
            show: true,
            headerStyle: headerStyle,
            Cell: (cell:any) => {
              return  <span title={cell.value}>
                        {cell.value}
                      </span>
            }
          }
        }

        return columns
      })
      return columns
    })
    
    return [columns, dataCopy]
  }
  componentDidMount(){
    this.buildColumns()
  }
  private buildDetailsTable() {
    const { i18n } = this.props;
    let filters:any = this.props.elections.declarations_csa_filters as IDeclarationCSAFilters;
    
    return (this.props.elections.isDeclarationDetailLoading ? 
      <div>
        {i18n._('Loading')}..
      </div> 
    : this.props.elections.decalarion_details === null || this.buildColumns()[1].length === 0 ?
      <div>
        {i18n._('No results')}
      </div> 
    :
    <div>
        { 
          this.props.elections.decalarion_details !== null && this.buildColumns()[1].length > 0 &&
          <ElectionTableDetails
          data={this.buildColumns()[1]}
          columns={this.buildColumns()[0]}
          filters={filters}
          showFilters={false}
          type={'declarationsCSA'}
          />
        }
      </div>
    )
  }
  public render(): React.ReactNode {  
    return (
      <div style={{paddingTop: 30}}>
        { this.buildDetailsTable()}
      </div>
    )
  }

}

const mapStateToProps = ({i18n, dashboard, search, user, elections} : IApplicationState, ownProps: RouteComponentProps<{}>) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    router: ownProps,
    dashboard,
    search,
    user,
    elections
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getXlsDeclarationCSA: (filters:IDeclarationCSAFilters) => dispatch(getXlsDeclarationCSA(filters))
});


export const DeclarationsCSAContent = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(DeclarationsCSAContentComponent)));
